class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const $html = $('html');
    const $trigger = $('.js-menu-trigger');
    const $drawer = $('.js-menu-drawer');

    const closeMenu = () => {
      if (!$html.hasClass('is-menu-open')) return;
      $html.removeClass('is-menu-open');
      $trigger.attr('aria-expanded', 'false').attr('aria-label', 'メニューを開く');
      $drawer.attr('hidden', true);
      scrollBan();
    };

    $trigger.on('click', function() {
      const isOpen = $html.hasClass('is-menu-open');
      if (isOpen) {
        closeMenu();
        return;
      }
      $html.addClass('is-menu-open');
      $trigger.attr('aria-expanded', 'true').attr('aria-label', 'メニューを閉じる');
      $drawer.removeAttr('hidden');
      scrollBan();
    });

    $drawer.on('click', 'a', closeMenu);
    $drawer.on('click', '.js-menu-overlay', closeMenu);

    const ACCESS_KEY = 'hitohataAccessBanner';
    const $access = $('.js-accessBanner');
    const closeAccess = () => {
      if (!$access.hasClass('is-active')) return;
      $access.removeClass('is-active').attr('aria-hidden', 'true');
      try {
        localStorage.setItem(ACCESS_KEY, '1');
      } catch (e) {}
      if ($html.hasClass('is-hidden')) scrollBan();
    };
    if ($access.length) {
      let seen = false;
      try {
        seen = !!localStorage.getItem(ACCESS_KEY);
      } catch (e) {}
      if (!seen) {
        $access.addClass('is-active').attr('aria-hidden', 'false');
        scrollBan();
      }
      $access.on('click', '.js-accessBannerClose', closeAccess);
      $(document).on('keydown.accessBanner', function(e) {
        if (e.key === 'Escape') closeAccess();
      });
    }

    const $programTabs = $('.js-programTabs .p-top-program-tab');
    const $programPanels = $('.js-programPanel');
    $programTabs.on('click', function() {
      const $tab = $(this);
      const index = $programTabs.index($tab);
      $programTabs
        .removeClass('is-active')
        .attr({ 'aria-selected': 'false', tabindex: '-1' });
      $tab.addClass('is-active').attr({ 'aria-selected': 'true', tabindex: '0' });
      $programPanels.attr('hidden', true).eq(index).removeAttr('hidden');
    });

    const $planTabs = $('.js-planTabs .p-top-plan-tab');
    const $planPanels = $('.js-planPanel');
    $planTabs.on('click', function() {
      const $tab = $(this);
      const index = $planTabs.index($tab);
      $planTabs
        .removeClass('is-active')
        .attr({ 'aria-selected': 'false', tabindex: '-1' });
      $tab.addClass('is-active').attr({ 'aria-selected': 'true', tabindex: '0' });
      $planPanels.attr('hidden', true).eq(index).removeAttr('hidden');
    });

    if (document.querySelector('.js-voiceSwiper')) {
      const $voiceBar = $('.p-top-voice-bar');
      const updateVoiceBar = (swiper) => {
        const total = swiper.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length || 1;
        const progress = (swiper.realIndex + 1) / total;
        $voiceBar.css('--progress', progress);
      };
      const voiceListSwiper = new Swiper('.js-voiceSwiper', {
        slidesPerView: 'auto',
        spaceBetween: 10,
        centeredSlides: true,
        initialSlide: 1,
        loop: true,
        loopedSlides: 3,
        loopAdditionalSlides: 3,
        speed: 600,
        grabCursor: true,
        autoplay: {
          delay: 2800,
          disableOnInteraction: false,
        },
        on: {
          init: updateVoiceBar,
          slideChange: updateVoiceBar,
        },
      });

      const $voiceModal = $('.js-voiceModal');
      const $voiceModalCurrent = $('.js-voiceModalCurrent');
      let voiceModalOpen = false;
      let voiceModalSwiper = null;

      const updateVoiceModalPager = (swiper) => {
        $voiceModalCurrent.text(swiper.realIndex + 1);
      };

      if (document.querySelector('.js-voiceModalSwiper')) {
        voiceModalSwiper = new Swiper('.js-voiceModalSwiper', {
          slidesPerView: 1,
          speed: 400,
          autoHeight: false,
          observer: true,
          observeParents: true,
          touchStartPreventDefault: false,
          spaceBetween: 10,
          navigation: {
            nextEl: '.js-voiceModalNext',
            prevEl: '.js-voiceModalPrev',
          },
          on: {
            init: updateVoiceModalPager,
            slideChange: updateVoiceModalPager,
          },
        });

        document.querySelectorAll('.p-top-voice-modal-card').forEach((card) => {
          card.addEventListener('touchmove', (event) => {
            event.stopPropagation();
          }, { passive: true });
        });
      }

      const openVoiceModal = (index) => {
        if ($html.hasClass('is-menu-open')) {
          closeMenu();
        }
        if (!voiceModalOpen) {
          scrollBan();
          voiceModalOpen = true;
        }
        $voiceModal.addClass('is-active').attr('aria-hidden', 'false');
        if (voiceListSwiper.autoplay) {
          voiceListSwiper.autoplay.stop();
        }
        if (voiceModalSwiper) {
          requestAnimationFrame(() => {
            voiceModalSwiper.update();
            voiceModalSwiper.slideTo(index, 0);
          });
        }
      };

      const closeVoiceModal = () => {
        if (!voiceModalOpen) return;
        $voiceModal.removeClass('is-active').attr('aria-hidden', 'true');
        scrollBan();
        voiceModalOpen = false;
        if (voiceListSwiper.autoplay) {
          voiceListSwiper.autoplay.start();
        }
      };

      $(document).on('click', '.js-voiceModalOpen', function(e) {
        e.preventDefault();
        const index = Number($(this).attr('data-index')) || 0;
        openVoiceModal(index);
      });

      $voiceModal.on('click', '.js-voiceModalClose', function() {
        closeVoiceModal();
      });

      $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
          closeVoiceModal();
        }
      });
    }

    if (document.querySelector('.js-supportSwiper')) {
      const $supportBar = $('.p-top-support-bar');
      const updateSupportBar = (swiper) => {
        const total = swiper.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length || 1;
        const progress = (swiper.realIndex + 1) / total;
        $supportBar.css('--progress', progress);
      };
      new Swiper('.js-supportSwiper', {
        slidesPerView: 'auto',
        spaceBetween: 15,
        centeredSlides: true,
        initialSlide: 1,
        loop: true,
        loopedSlides: 3,
        loopAdditionalSlides: 3,
        speed: 600,
        grabCursor: true,
        autoplay: {
          delay: 2800,
          disableOnInteraction: false,
        },
        on: {
          init: updateSupportBar,
          slideChange: updateSupportBar,
        },
      });
    }

    if (document.querySelector('.js-scroll')) {
      new ScrollHint('.js-scroll', {
        i18n: {
          scrollable: '横スクロール',
        },
        suggestiveShadow: true,
      });
    }

    const $planFeeModal = $('.js-planFeeModal');
    const $planFeePanels = $('.js-planFeePanel');
    const closePlanFee = () => {
      if (!$planFeeModal.hasClass('is-active')) return;
      $planFeeModal.removeClass('is-active').attr('aria-hidden', 'true');
      if ($html.hasClass('is-hidden')) scrollBan();
    };
    $('.js-planFeeOpen').on('click', function() {
      const plan = $(this).data('plan');
      $planFeePanels.attr('hidden', true).filter('[data-plan="' + plan + '"]').removeAttr('hidden');
      $planFeeModal.addClass('is-active').attr('aria-hidden', 'false');
      if (!$html.hasClass('is-hidden')) scrollBan();
      requestAnimationFrame(function() {
        window.dispatchEvent(new Event('resize'));
      });
    });
    $planFeeModal.on('click', '.js-planFeeClose', closePlanFee);
    $(document).on('keydown.planFee', function(e) {
      if (e.key === 'Escape') closePlanFee();
    });

    if (document.querySelector('.js-checkSwiper')) {
      new Swiper('.js-checkSwiper', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        loopedSlides: 8,
        loopAdditionalSlides: 3,
        speed: 600,
        grabCursor: true,
        autoplay: {
          delay: 2800,
          disableOnInteraction: false,
        },
      });
    }

    const $messageAcc = $('.js-messageAcc');
    if ($messageAcc.length) {
      $messageAcc.on('click', '.js-messageAccBtn', function() {
        const $wrap = $(this).closest('.js-messageAcc');
        const open = !$wrap.hasClass('is-active');
        $wrap.toggleClass('is-active', open);
        $(this).attr('aria-expanded', open ? 'true' : 'false');
        $(this).find('.p-top-message-acc-ttl').text(open ? '閉じる' : '続きを読む');
      });
    }

    $(document).on('click', 'a[href="#cashback-terms"]', function() {
      const $btn = $('#cashback-terms .js-accordion');
      if ($btn.length && !$btn.hasClass('is-active')) {
        $btn.trigger('click');
      }
    });

    const flags = document.querySelectorAll('.p-top-fv-illust .js-fv-flag');
    if (flags.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const rand = (min, max) => min + Math.random() * (max - min);
      flags.forEach((flag) => {
        const play = () => {
          flag.classList.remove('is-hide');
          flag.classList.add('is-show');
          setTimeout(() => {
            flag.classList.remove('is-show');
            flag.classList.add('is-hide');
            setTimeout(play, rand(700, 2600));
          }, rand(1600, 2800));
        };
        setTimeout(play, rand(200, 1600));
      });
    }
  }
}
